import { useCallback, useEffect, useState } from "react";
import socketManager from "../services/socket/socketManager";

export function useSocket() {
  const [connected, setConnected] = useState(socketManager.isConnected());

  useEffect(() => {
    const unsubConnect = socketManager.onConnect(() => setConnected(true));
    const unsubDisconnect = socketManager.onDisconnect(() => setConnected(false));
    return () => {
      unsubConnect();
      unsubDisconnect();
    };
  }, []);

  const connect = useCallback(() => {
    socketManager.connect();
  }, []);

  const disconnect = useCallback(() => {
    socketManager.disconnect();
  }, []);

  const on = useCallback((event, callback) => {
    return socketManager.on(event, callback);
  }, []);

  const emit = useCallback((event, data) => {
    return socketManager.emit(event, data);
  }, []);

  return {
    connect,
    disconnect,
    on,
    emit,
    connected,
  };
}
